import { useSharedGlobalConfig } from "../useSharedGlobalConfig/useSharedGlobalConfig";
const useIsFs2FinalRelease = () => {
  const { isFs2Release } = useSharedGlobalConfig();

  return isFs2Release;
};

export { useIsFs2FinalRelease };
